import React, {useRef, useState, useEffect} from 'react';
import {searchJob} from 'service/JobService';
import {throttle} from 'lodash';
import {useAppContext} from 'contexts';

const delay = 3000;

const jobSearch = () => {
    const abortController = useRef<AbortController>(null);

    const {
        setSideBarOverlays,
        searchInput,
        resultReceived,
        setResultReceived,
        searchOnText,
        setsearchOnText,
        searchOnButton,
        setsearchOnButton,
        isSearching,
        setisSearching,
    } = useAppContext();

    const [resultData, setResultData] = useState([]);

    const throttleSearch = throttle(
        (event: React.KeyboardEvent<HTMLInputElement>) => {
            void executeSearch(event);
        },
        delay,
        {
            leading: false,
            trailing: true,
        }
    );

    const callSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (['ArrowDown', 'ArrowLeft'].includes(event.key)) return;

        if (event.key === 'Escape') {
            throttleSearch.cancel();
            resetResults(true);
            event.currentTarget.blur();
            return;
        }

        throttleSearch.cancel();
        setisSearching(false);
        setResultReceived(false);
        cancelRequest();

        if (event.key === 'Enter') {
            void executeSearch(event);
        } else {
            throttleSearch(event);
        }
    };

    const cancelRequest = () =>
        abortController.current && abortController.current.abort();

    const executeSearch = async (
        event: React.KeyboardEvent<HTMLInputElement>
    ) => {
        const target = event.currentTarget;
        if (target.value.length < 3) return;

        setSideBarOverlays(true);
        setsearchOnButton('searchOnButton');
        setsearchOnText('searchOnText');
        setisSearching(true);
        setResultReceived(false);

        abortController.current = new AbortController();

        const searchData = Object.values(
            await searchJob(target.value, abortController.current.signal)
        );

        setResultData(searchData);
        setisSearching(false);
        setResultReceived(true);
    };

    const resetResults = (reset = false) => {
        if (searchInput.current.value == '' || reset) {
            setResultReceived(false);
            setResultData([]);
            setisSearching(false);
            setSideBarOverlays(false);
            setsearchOnButton('');
            setsearchOnText('');
            cancelRequest();
            searchInput.current.value = '';
        }
    };

    useEffect(() => {
        return () => {
            throttleSearch.cancel();
        };
    }, [resultData, isSearching, resultReceived]);

    return {
        resultData,
        resetResults,
        callSearch,
        searchOnText,
        searchOnButton,
        isSearching,
    };
};

export {jobSearch};
